(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["voodoo-baby-password"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.vb-pw').forEach(function(root){
  var d=root.dataset,reducedMotion=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  requestAnimationFrame(function(){root.classList.add('is-loaded');});
  if(root.querySelector('.vb-pw__notice')){
    root.classList.add('vb-pw--success');
    if(history.replaceState)history.replaceState(null,'',window.location.pathname+window.location.search);
    window.scrollTo(0,0);
    requestAnimationFrame(function(){window.scrollTo(0,0);});
    window.setTimeout(function(){window.scrollTo(0,0);},0);
  }
  var mobBp=parseInt(d.vbMobBp,10)||760;
  function fitMainTitle(){
    if(root.querySelector('.vb-pw__copy-img--hero'))return;
    var wrap=root.querySelector('.vb-pw__title-wrap'),dangerous=root.querySelector('[data-fit-line="dangerous"]'),stay=root.querySelector('[data-fit-line="stay"]');
    if(!wrap||!dangerous)return;
    dangerous.style.fontSize='';if(stay)stay.style.fontSize='';
    var maxWidth=wrap.clientWidth-8;if(maxWidth<=0)return;
    var isMobile=window.innerWidth<=mobBp,isXs=window.innerWidth<=420,dSize=parseFloat(window.getComputedStyle(dangerous).fontSize);
    var dFloor=isXs?parseInt(d.vbDMinXs,10):(isMobile?parseInt(d.vbDMinM,10):parseInt(d.vbDMin,10)),guard=0;
    while(dangerous.scrollWidth>maxWidth&&dSize>dFloor&&guard<160){dSize-=1;dangerous.style.fontSize=dSize+'px';guard+=1;}
    if(stay){
      var stayMax=isMobile?parseInt(d.vbSMaxM,10):parseInt(d.vbSMax,10),stayMin=isXs?parseInt(d.vbSMinXs,10):(isMobile?parseInt(d.vbSMinM,10):parseInt(d.vbSMin,10));
      var titleMax=isMobile?parseInt(d.vbTMaxM,10):parseInt(d.vbTMax,10),ratio=stayMax/titleMax,sSize=Math.max(stayMin,Math.round(dSize*ratio));
      stay.style.fontSize=sSize+'px';guard=0;
      while(stay.scrollWidth>maxWidth&&sSize>stayMin&&guard<80){sSize-=1;stay.style.fontSize=sSize+'px';guard+=1;}
    }
  }
  fitMainTitle();window.addEventListener('resize',fitMainTitle);
  if(document.fonts&&document.fonts.ready)document.fonts.ready.then(fitMainTitle);
  window.setTimeout(fitMainTitle,100);
  var timerEl=root.querySelector('.vb-pw__timer'),targetStr=root.getAttribute('data-countdown');
  if(timerEl&&targetStr){
    var target=new Date(targetStr);if(isNaN(target.getTime()))target=new Date(targetStr.replace(' ','T'));
    var flipDuration=parseInt(d.vbFlip,10)||620,prev={days:null,hours:null,minutes:null,seconds:null};
    function pad(n){return n<10?'0'+n:String(n);}
    function setFlipDigits(flipEl,value){flipEl.querySelectorAll('.vb-pw__flip-digit').forEach(function(node){node.textContent=value;});flipEl.setAttribute('data-value',value);}
    function resetFlipPages(flipEl){
      var upper=flipEl.querySelector('.vb-pw__flip-page--upper'),lower=flipEl.querySelector('.vb-pw__flip-page--lower');
      [upper,lower].forEach(function(page){if(!page)return;page.style.animation='none';page.style.transform=page.classList.contains('vb-pw__flip-page--upper')?'rotateX(0deg)':'rotateX(90deg)';});
      void flipEl.offsetWidth;[upper,lower].forEach(function(page){if(!page)return;page.style.animation='';page.style.transform='';});
    }
    function finishFlip(flipEl,nextVal){setFlipDigits(flipEl,nextVal);flipEl.classList.remove('is-flipping');resetFlipPages(flipEl);var pending=flipEl.getAttribute('data-pending');flipEl.removeAttribute('data-pending');if(pending&&pending!==nextVal)runSplitFlip(flipEl,pending,true);}
    function runSplitFlip(flipEl,nextVal,animate){
      var current=flipEl.getAttribute('data-value')||'00';if(current===nextVal)return;
      if(!animate||reducedMotion){setFlipDigits(flipEl,nextVal);flipEl.classList.remove('is-flipping');flipEl.removeAttribute('data-pending');return;}
      if(flipEl.classList.contains('is-flipping')){flipEl.setAttribute('data-pending',nextVal);return;}
      var pageUpFront=flipEl.querySelector('[data-role="page-up-front"]'),pageUpBack=flipEl.querySelector('[data-role="page-up-back"]'),pageLowFront=flipEl.querySelector('[data-role="page-low-front"]');
      if(!pageUpFront||!pageUpBack||!pageLowFront){setFlipDigits(flipEl,nextVal);return;}
      pageUpFront.textContent=current;pageUpBack.textContent=nextVal;pageLowFront.textContent=nextVal;resetFlipPages(flipEl);flipEl.classList.add('is-flipping');
      var upper=flipEl.querySelector('.vb-pw__flip-page--upper'),lower=flipEl.querySelector('.vb-pw__flip-page--lower'),ended=0;
      function onPageEnd(e){if(!e||!e.animationName||e.animationName.indexOf('vb-pw-page')===-1)return;ended+=1;if(ended>=2){upper.removeEventListener('animationend',onPageEnd);lower.removeEventListener('animationend',onPageEnd);finishFlip(flipEl,nextVal);}}
      upper.addEventListener('animationend',onPageEnd);lower.addEventListener('animationend',onPageEnd);
      window.setTimeout(function(){if(flipEl.classList.contains('is-flipping')){upper.removeEventListener('animationend',onPageEnd);lower.removeEventListener('animationend',onPageEnd);finishFlip(flipEl,nextVal);}},flipDuration+80);
    }
    function tick(initial){
      var now=new Date(),diff=target-now,d=0,h=0,m=0,s=0;
      if(diff>0){d=Math.floor(diff/86400000);h=Math.floor((diff%86400000)/3600000);m=Math.floor((diff%3600000)/60000);s=Math.floor((diff%60000)/1000);}
      var units={days:pad(d),hours:pad(h),minutes:pad(m),seconds:pad(s)};
      Object.keys(units).forEach(function(key){var flipEl=timerEl.querySelector('.vb-pw__flip[data-unit="'+key+'"]');if(!flipEl)return;if(prev[key]!==units[key]){runSplitFlip(flipEl,units[key],!initial);prev[key]=units[key];}});
    }
    tick(true);window.setInterval(function(){tick(false);},1000);
  }
  var allowParallax=root.getAttribute('data-parallax')==='true'&&!reducedMotion&&window.innerWidth>mobBp&&!window.matchMedia('(pointer: coarse)').matches;
  if(allowParallax){
    var layers=root.querySelectorAll('[data-parallax-layer]'),mx=0,my=0,cx=0,cy=0;
    root.addEventListener('mousemove',function(e){var rect=root.getBoundingClientRect();mx=((e.clientX-rect.left)/rect.width-0.5)*2;my=((e.clientY-rect.top)/rect.height-0.5)*2;});
    (function parallaxLoop(){cx+=(mx-cx)*0.06;cy+=(my-cy)*0.06;layers.forEach(function(layer){layer.style.transform='translate3d('+(cx*16)+'px, '+(cy*12)+'px, 0)';});requestAnimationFrame(parallaxLoop);})();
  }
});

  } catch(e) { console.error(e); }
})();
})();
